import { Box, Stack, Typography } from "@mui/material"
import { round2 } from "../format-utils"
import { CostFigure } from "./cost-figure"

export function FacilityDrillDownRow({ item, currencySymbol }) {
    return (
        <Stack
            direction="row"
            alignItems="center"
            data-cy="facility-drill-down-row"
            sx={{ px: 2, py: 1, borderBottom: 1, borderColor: "divider", "&:last-child": { borderBottom: 0 } }}
        >
            <Box sx={{ flex: 2 }}>
                <Typography variant="body2">{item.label}</Typography>
            </Box>
            <Box sx={{ flex: 1, textAlign: "right" }}>
                <Typography variant="body2" color="text.secondary">
                    {round2(item.hours)}h
                </Typography>
            </Box>
            <Box sx={{ flex: 1, textAlign: "right" }}>
                <CostFigure value={item.cost} currencySymbol={currencySymbol} fontWeight={500} />
            </Box>
            <Box sx={{ width: 60, textAlign: "right" }}>
                <Typography variant="caption" color="text.secondary">
                    {item.count} task{item.count === 1 ? "" : "s"}
                </Typography>
            </Box>
        </Stack>
    )
}
